<template>
  <div class="promotion">
    <h1 class="display-1 grey--text">
      Asesoramiento ilimitado con todas las gestiones laborales que requiere cada negocio
    </h1>

    <p>
      A través del módulo laboral, nuestros clientes acceden a un servicio completo con el
      asesoramiento y todos los trámites que se necesitan para cumplir con las obligaciones legales
      en la materia.
    </p>

    <h2 class="heading secondary--text">Resumen de servicios</h2>

    <ul>
      <li>
        Tramitación de altas, bajas y variaciones de trabajadores en Régimen General de la Seguridad
        Social y en el RETA.
      </li>

      <li>
        Confección y registro de contratos de trabajo según modelos oficiales.
      </li>

      <li>Confección de finiquitos y certificados de empresa.</li>

      <li>
        Realización de las nóminas de los empleados y ficheros de remesas bancarias para su pago.
      </li>

      <li>
        Cálculos de IRPF de empleados, según situación familiar e ingresos.
      </li>

      <li>
        Confección de los Recibos de Liquidación de Cotizaciones y Relación Nominal de Trabajadores
        (antiguos TC1/TC2).
      </li>

      <li>
        Confección mensual/trimestral del ingreso a cuenta de las retenciones del IRPF (modelos
        111/216) y del resumen
      </li>

      <li>
        anual de las retenciones del IRPF (modelos 190/296). Estatal y forales.
      </li>

      <li>Confección del certificado de rendimientos del trabajo.</li>

      <li>
        Gestiones con la Tesorería Territorial de la Seguridad Social (TGSS) y el Servicio Público
        de Empleo (SEPE).
      </li>

      <li>
        Gestión de partes de incapacidad temporal y de accidentes de trabajo.
      </li>
    </ul>

    <br />
    <br />
    <p>
      Si ya tienes trabajadores contratados, a través de la Sección Laboral de OpenBox podrás
      acceder y descargar las nóminas mensuales de tus empleados, así como los documentos de
      liquidación de las cotizaciones a la Seguridad Social, etc.
    </p>

    <p>
      Si aún no tienes empleados y vas a realizar tu primera contratación, comunícaselo a tu asesor
      personal para que te facilite la información necesaria para ello. Y recuerda que próximamente
      esta sección sincronizará con la información laboral de tu negocio y podrás ver en tiempo real
      la plantilla activa, el histórico de contratos realizados, y podrás cursar las solicitudes de
      altas y bajas de trabajadores.
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.promotion {
  font-size: 1.2rem;
}
</style>
